import React, { useEffect, useState } from 'react';
import FichajeQR from './FichajeQR';

// ===== SISTEMA DE VERSIONADO PARA FORZAR LOGOUT =====
// Cambiar APP_VERSION cada vez que necesites que los usuarios
// sean expulsados al login (ej: cambio de QR a GPS).
// Al abrir la app, si la versión no coincide (o es la primera vez
// que se carga esta versión), se limpia TODO y se redirige a /login.

const APP_VERSION = '2.0.1-GPS-IOS-FIX';

export default function App() {
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    if (needsForceLogout()) {
      forceLogout();
    }
  }, []);

  function needsForceLogout() {
    try {
      const storedVersion = localStorage.getItem('APP_VERSION');

      // CASO 1: Ya tiene la versión correcta → todo bien
      if (storedVersion === APP_VERSION) {
        return false;
      }

      // CASO 2: Tiene una versión DIFERENTE → actualización detectada
      if (storedVersion && storedVersion !== APP_VERSION) {
        console.log(`[versioning] Actualización: ${storedVersion} → ${APP_VERSION}`);
        return true;
      }

      // CASO 3: NO tiene APP_VERSION (usuario nuevo o viene de la app antigua QR)
      // Comprobar si tiene datos de la app antigua (dni, nombre, etc.)
      const hasDni = localStorage.getItem('dni');
      const hasNombre = localStorage.getItem('nombre');
      const hasUserId = localStorage.getItem('user_id');
      
      if (hasDni || hasNombre || hasUserId) {
        // Viene de la app antigua QR → forzar logout para limpiar todo
        console.log('[versioning] Usuario antiguo QR detectado → forzar logout');
        return true;
      }

      // CASO 4: No tiene nada → usuario completamente nuevo, guardar versión
      localStorage.setItem('APP_VERSION', APP_VERSION);
      return false;
    } catch (e) {
      console.warn('[versioning] Error:', e.message);
      return false;
    }
  }

  function forceLogout() {
    console.log('[logout] Limpiando sesión antigua y redirigiendo a login...');
    setIsReloading(true);

    // 1. Limpiar storage
    try { localStorage.clear(); } catch (e) {}
    try { sessionStorage.clear(); } catch (e) {}

    // 2. Guardar la nueva versión DESPUÉS de limpiar
    try { localStorage.setItem('APP_VERSION', APP_VERSION); } catch (e) {}

    // 3. Limpiar cookies
    try {
      document.cookie.split(';').forEach(c => {
        const name = c.split('=')[0].trim();
        if (name) {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
        }
      });
    } catch (e) {}

    // 4. Desregistrar service workers para eliminar caché antigua
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
      }).catch(() => {});
    }

    // 5. Limpiar cachés del navegador (Cache API)
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      }).catch(() => {});
    }

    // 6. Forzar recarga completa (no desde caché)
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  }

  if (isReloading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        flexDirection: 'column', gap: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
      }}>
        <div style={{
          width: '60px', height: '60px',
          border: '4px solid rgba(255,255,255,0.3)', borderTop: '4px solid white',
          borderRadius: '50%', animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ color: 'white', fontSize: '18px', fontWeight: '700', margin: 0 }}>
          Actualizando sistema...
        </p>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px', margin: 0 }}>
          Esto solo tardará un momento
        </p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return <FichajeQR />;
}
